import React from 'react'

const RightAbout = () => {
    return ( 
        <div className="right">

            <ul>

            <li>
                <p>
                <span>Birthday:</span>16.02.1998
                </p>
            </li>

            <li>
                <p>
                <span>Age:</span>24
                </p>
            </li>

            <li>
                <p>
                <span>Address:</span>Cortazar, Gto. México
                </p>
            </li>

            <li>
                <p>
                <span>Phone:</span>
                <a href="tel:+524111010375">+52 411 101 0375</a>
                </p>
            </li>

            <li>
                <p>
                <span>Study:</span>Insituto Tecnológico de Celaya
                </p>
            </li>

            {/* <li>
                <p>
                <span>Freelance:</span>Available
                </p>
            </li> */}

            <li>
                <p>
                <span>Email:</span> <a href="mailto:oscar.villanueva.prieto@gmail.com">oscar.villanueva.prieto@gmail.com</a>
                </p>
            </li>

            </ul>
            
        </div>
    );
}
 
export default RightAbout;